/* eslint-disable import/prefer-default-export */
import { saveAs } from 'file-saver'
import axios from '../Axios'

const module = '/programs-sync'

export const getProgramsSync = async (
  filtersProgramsSync,
  page = 0,
  limit = 6
) => {
  const { program } = filtersProgramsSync
  const { data } = await axios.get(
    `${module}/?program=${program}&page=${page}&limit=${limit}`
  )
  return data
}

export const generateTemplateFile = async (body) => {
  const response = await axios.post(`${module}/generate-template-file`, body, {
    responseType: 'arraybuffer'
  })
  const dirtyFileName = response.headers['content-disposition']
  const regex =
    /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/
  const fileName = dirtyFileName.match(regex)[3]

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  saveAs(blob, fileName)

  return response
}

export const uploadMasivePrograms = async (formData) => {
  const { data } = await axios.post(`/programs/upload-masive/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return data
}
